import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/api';
import AppLayout from '../components/AppLayout';
import PageTitle from '../components/PageTitle';
import '../styles/pages/ForgotPasswordPage.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');

  useEffect(() => {
    document.title = 'パスワードリセット | はしもと栄養パートナー';
  }, []);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      const response = await api.post('/api/auth/forgot-password', { email });
      setMessage(response.data.message);
      setSubmitted(true);
    } catch (error) {
      setError(error.response?.data?.message || 'パスワードリセット申請に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <AppLayout hideTabNav>
        <PageTitle title="メール送信完了" subtitle="確認してください" icon="📧" />
        <div className="tsumugi-container py-6">
          <div className="max-w-md mx-auto">
            <div className="tsumugi-card text-center">
              <div className="forgot-password-page__success-icon-wrapper">
                <svg className="forgot-password-page__success-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="forgot-password-page__success-title">
                メール送信完了
              </h2>
              <div className="forgot-password-page__success-box">
                <p className="forgot-password-page__success-message">{message}</p>
              </div>
              <div className="forgot-password-page__warning-box">
                <h4 className="forgot-password-page__warning-title">
                  ⚠️ 重要：メールが届かない場合
                </h4>
                <div className="forgot-password-page__warning-highlight">
                  <p className="forgot-password-page__warning-highlight-text">
                    📧 <strong>迷惑メール・スパムフォルダ</strong>を必ずご確認ください！
                  </p>
                </div>
                <ul className="forgot-password-page__warning-list">
                  <li>• Gmail・Yahoo!メールなどで迷惑メールに分類される可能性があります</li>
                  <li>• メールアドレスの入力に間違いがないかご確認ください</li>
                  <li>• 数分お待ちいただいてからご確認ください</li>
                </ul>
              </div>
              <Link
                to="/login"
                className="tsumugi-btn-primary inline-block"
              >
                ログインページに戻る
              </Link>
            </div>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout hideTabNav>
      <PageTitle title="パスワードリセット" subtitle="メールアドレスを入力してください" icon="🔑" />
      <div className="tsumugi-container py-6">
        <div className="max-w-md mx-auto">
          <form onSubmit={handleSubmit}>
            <div className="tsumugi-card space-y-4">
              {error && (
                <div className="forgot-password-page__error-box">
                  {error}
                </div>
              )}

              <div>
                <label htmlFor="email" className="forgot-password-page__label">
                  メールアドレス
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="forgot-password-page__input"
                  placeholder="メールアドレスを入力"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="tsumugi-btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {loading ? (
                    <div className="flex items-center justify-center">
                      <div className="animate-spin -ml-1 mr-3 h-5 w-5">
                        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </div>
                      送信中...
                    </div>
                  ) : (
                    'パスワードリセットメールを送信'
                  )}
                </button>
              </div>

              <div className="text-center">
                <Link to="/login" className="forgot-password-page__login-link">
                  ログインページに戻る
                </Link>
              </div>
            </div>
          </form>
        </div>
      </div>
    </AppLayout>
  );
};

export default ForgotPasswordPage;
